import React from 'react';
import {
    usePropertyFetching,
    usePropertyPresentation,
} from '../../../../contextsProperty/ContextProperties';
import Card from '../../../../../muiComponents/Card';
import GridChild from '../../../../../muiComponents/GridChild';
import Grid from '../../../../../muiComponents/Grid';
import Image from '../../../../components/Image';
import { imageColumnGrid } from '../../../../../utils/property/propertyUtils';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';
import { ImageState } from '../../../../../types/properties/propertyTypes';
import {
    gridSpacing30,
    gridSpacing40,
} from '../../../../../utils/commonVariables/grid';

const ImagesSection = () => {
    const { images } = usePropertyPresentation();
    const { isFetching } = usePropertyFetching();

    const displayImages: (ImageState | null)[] = [...images];
    while (displayImages.length < 4) {
        displayImages.push(null);
    }

    return (
        <>
            {images.length ? (
                <section>
                    <Card className='flex padding20'>
                        {isFetching ? (
                            <LoadingPlaceholder
                                variant='rounded'
                                width={'100%'}
                                height={200}
                            />
                        ) : (
                            <Grid
                                columnSpacing={gridSpacing30}
                                rowSpacing={gridSpacing40}
                                style={{ width: '100%' }}
                            >
                                {displayImages.map((img, ind) => (
                                    <GridChild
                                        gridProps={imageColumnGrid}
                                        key={img?.id || ind}
                                    >
                                        <Image
                                            className='completed-presentation__image'
                                            src={img?.url || ''}
                                            useLocalBaseUrl={false}
                                        />
                                    </GridChild>
                                ))}
                            </Grid>
                        )}
                    </Card>
                </section>
            ) : (
                ''
            )}
        </>
    );
};

export default ImagesSection;
